<template>
    <div class="goods-box">
        <a-button class="mb15" type="primary" @click="handleBindEvent">{{$t('forum.bind_goods')/* 绑定门票 */}}</a-button>
        <div v-for="(item, index) in typeList" :key="index" class="goods-item" v-show="isShowDiv(item)">
            <div class="type-title bold flex">
                <div>{{ item.name }}</div>
            </div>
            <!-- 一级 -->
            <template v-if="!item.children || item.children.length == 0">
                <a-table
                    v-if="dataSource.filter(it => it.type_id == item.id).length > 0"
                    ref="table"
                    class="mt15"
                    :rowKey="record => record.goods_id"
                    :columns="columns"
                    :data-source="dataSource.filter(it => it.type_id == item.id)"
                    :pagination="false"
                    size="small"
                    :expand-icon-column-index="1"
                    :defaultExpandAllRows="true"
                    :custom-row="customRow">
                    <template slot="drag" slot-scope="text, record">
                        <i class="medcon fs24 med-Drag"></i>
                    </template>
                    <span slot="index" slot-scope="text, record, index">
                        {{ index + 1 }}
                    </span>
                    <span slot="name" slot-scope="text, record">
                        <a-button @click="handleShowGoodsData(record)" type="link">{{ record.goods_name }}</a-button>
                    </span>
                    <span slot="inventory" slot-scope="text, record">
                        <!-- 库存 -->
                        <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                        <!-- 销量 -->
                        <span>/{{ record.sale_num }}</span>
                    </span>
                    <span slot="price" slot-scope="text, record">
                        {{ currencyType[record.currency] }} :
                        {{ record.price }}
                    </span>
                    <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>

                    <span slot="action" slot-scope="text, record">
                        <a @click="handleShowGoodsData(record)">
                            <!--    查看   -->
                            {{ $t('user.view') }}
                        </a>
                        <a-divider type="vertical" />
                        <a @click="handleDel(record)" class="del-button">
                            {{$t('forum.del_bind')/* 解除绑定 */}}
                        </a>
                    </span>
                </a-table>
            </template>
            <!-- 二级 -->
            <template v-if="item.children && item.children.length > 0">
                <div v-for="(it, inde) in item.children" class="pl20 pr20" :key="inde" v-show="isShowDiv(it)">
                    <div class="type-title bold flex mt15">
                        <div>{{ it.name }}</div>
                    </div>
                    <a-table
                        ref="table"
                        class="mt15"
                        :rowKey="record => record.goods_id"
                        :columns="columns"
                        v-if="dataSource.filter(goods => goods.type_id == it.id).length > 0"
                        :data-source="dataSource.filter(goods => goods.type_id == it.id)"
                        :pagination="false"
                        size="small"
                        :expand-icon-column-index="1"
                        :defaultExpandAllRows="true"
                        :custom-row="customRow"
                    >
                        <template slot="drag" slot-scope="text, record">
                            <i class="medcon fs24 med-Drag"></i>
                        </template>
                        <span slot="index" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </span>
                        <span slot="name" slot-scope="text, record">
                            <a-button @click="handleShowGoodsData(record)" type="link">{{ record.goods_name }}</a-button>
                        </span>
                        <span slot="inventory" slot-scope="text, record">
                            <!-- 库存 -->
                            <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                            <!-- 销量 -->
                            <span>/{{ record.sale_num }}</span>
                        </span>
                        <span slot="price" slot-scope="text, record">
                            {{ currencyType[record.currency] }} :
                            {{ record.price }}
                        </span>
                        <span slot=""></span>
                        <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>

                        <span slot="action" slot-scope="text, record">
                            <a @click="handleShowGoodsData(record)">
                                <!--    编辑   -->
                                {{ $t('user.view') }}
                            </a>
                            <a-divider type="vertical" />
                            <a @click="handleDel(record)" class="del-button">
                                {{$t('forum.del_bind')/* 解除绑定 */}}
                            </a>
                        </span>
                    </a-table>
                </div>
            </template>
        </div>
         <!--  门票详情  -->
        <goods-info ref="goodsInfo" :visible="visible" @close="handleClose" :dataInfo="dataInfo" />
        <bind-goods-modal ref="bindGoodsModalRef" @reset="getListData"/>
    </div>
</template>

<script>

import tableDrag from '@/utils/table.drag.mixins.js';
import { currencyType } from '@/config/const.js';
import goodsInfo from '@/views/goods-module/components/goods-info.vue';
import bindGoodsModal from './bind-goods-modal.vue'
export default {
    name: 'Goods',
    mixins: [tableDrag],
    components: {
        bindGoodsModal,
        goodsInfo
    },
    data() {
        return {
            typeList: [], // 门票类型
            currencyType,
            columns: [
                {
                    title: this.$t('formConfig.sort' /* 排序 */),
                    scopedSlots: { customRender: 'drag' },
                    fixed: 'left',
                    width: 80
                },
                {
                    // title: '门票名称',
                    title: this.$t('store.goods_name'),
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                    align: 'center',
                    fixed: 'left',
                    width: 180
                },
                {
                    // title: '金额',
                    title: this.$t('store.goods_money'),
                    dataIndex: 'price',
                    scopedSlots: { customRender: 'price' },
                    align: 'center',
                    width: 100
                },
         
                {
                    title: `${this.$t('store.inventory')}/${this.$t('store.sales_volume')}`,
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' },
                    width: 100
                },
                {
                    // title: '销售时段',
                    title: this.$t('store.sales_period'),
                    align: 'center',
                    width: 200,
                    scopedSlots: { customRender: 'sales_period' }
                },
                {
                    // title: '操作',
                    title: this.$t('layout.operation'),
                    dataIndex: 'action',
                    width: 130,
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right'
                }
            ], // 表格列
            dataSource: [], // 表格数据
            dataInfo: {},
            visible: false
        };
    },
    created() {
        this.getListData();
        this.getGoodsTypeList();
    },
    computed: {
       
    },
    methods: {
        isShowDiv (item) {
            let arr = this.dataSource.filter(it => it.type_id == item.id)
            if (item.children.length > 0) {
                item.children.forEach((it,ind) => {
                    let carr = this.dataSource.filter(i => i.type_id == it.id)
                    arr = arr.concat(carr)
                })
            }
            if (arr.length > 0) {
                return true
            } else {
                return false
            }
        },
        // 获取列表数据
        getListData() {
            let data = {
                page: 1,
                limit: 999
            };
            this.loading = true;
            this.$request.get({ url: 'getForumGoodsList', data }).then(res => {
                this.dataSource = res.data.data;
                this.loading = false;
            });
        },
        handleClose() {
            this.dataInfo = {};
            this.visible = false;
        },
        handleShowGoodsData(data) {
            data.number = data.goods_number;
            data.inventory = data.sales_volume;
            data.id = data.goods_id;
            this.dataInfo = data;
            this.visible = true;
        },
        handleBindEvent () {
            let ids = []
            this.dataSource.forEach(it => ids.push(it.goods_id))
            this.$refs.bindGoodsModalRef.show(ids)
        },
        // 拖拽成功方法
        dragSuccess() {
            let ids = [];
            this.dataSource.forEach((it, idx) => {
                ids.push(it.id);
            });
            this.$request.post({ url: 'forumGoodsSort', data: { language: this.language, ids } }).then(res => {
                this.$message.success(res.message);
            });
        },
        // 获取门票全部分类
        getGoodsTypeList() {
            this.$request.get({ url: 'getGoodsTypeList' }).then(res => {
                this.typeList = res.data;
            });
        },
         // 解绑门票
        handleDel(record) {
            this.$confirm({
                title: '',
                content:this.$t('forum.confirm_delete_forum_goods') /* 确定解绑该门票吗？ */,
                okText: this.$t('forum.confirm'),/* 确定 */
                cancelText: this.$t('forum.cancel'),
                onOk: () => {
                    let data = {
                        goods_ids: record.goods_id,
                    };
                    this.$request.post({ url: 'submitCancelGoodsBind', data }).then(res => {
                        this.getListData()
                    });
                },
                onCancel: () => {
                },
            });
        }
    },
    computed: {}
};
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
    margin-bottom: 10px !important;
}
.goods-item {
    border: 1px solid #e3e4e5;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
}
</style>
